<template>
  <svg
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="none"
  >
    <path
      d="M34.25 33.75L43.25 42.75"
      stroke="url(#paint0_linear_8712_278229)"
      stroke-width="6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M23 36.75C30.8701 36.75 37.25 30.3701 37.25 22.5C37.25 14.6299 30.8701 8.25 23 8.25C15.1299 8.25 8.75 14.6299 8.75 22.5C8.75 30.3701 15.1299 36.75 23 36.75Z"
      stroke="url(#paint1_linear_8712_278229)"
      stroke-width="6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8712_278229"
        x1="34.25"
        y1="38.2503"
        x2="43.2505"
        y2="38.2503"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9681DB" />
        <stop offset="1" stop-color="#79BAC0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8712_278229"
        x1="8.75"
        y1="22.5011"
        x2="37.2516"
        y2="22.5011"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9681DB" />
        <stop offset="1" stop-color="#79BAC0" />
      </linearGradient>
    </defs>
  </svg>
</template>
